import { Breadcrumbs, Spinner, Tooltip, Wrapper } from '@forge/common'
import { AdapterNewForm } from '@forge/features/adapters'
import { InformationCircleIcon } from '@heroicons/react/outline'
import { Suspense } from 'react'
import { Helmet } from 'react-helmet-async'

export function AdapterNew() {
  return (
    <>
      <Helmet>
        <title>New Adapter</title>
      </Helmet>

      <Wrapper>
        <Breadcrumbs>
          <Breadcrumbs.Crumb to="/adapters">Data Adapters</Breadcrumbs.Crumb>
          <Breadcrumbs.Crumb to={`/adapters/new`}>
            New Adapter
          </Breadcrumbs.Crumb>
        </Breadcrumbs>

        <div className="flex w-full">
          <h1 className="flex text-4xl font-medium">
            New Adapter
            <div className="px-2 py-2">
              <Tooltip
                delay={700}
                placement="right"
                content="Enter data feed credentials to add a data adaper to Forge.">
                <InformationCircleIcon className="h-5" />
              </Tooltip>
            </div>
          </h1>
        </div>

        <Suspense
          fallback={
            <div className="flex justify-center p-4">
              <div className="h-5 w-5 text-orange-400">
                <Spinner />
              </div>
            </div>
          }>
          <div className="flex justify-center">
            <AdapterNewForm />
          </div>
        </Suspense>
      </Wrapper>
    </>
  )
}
